import Container from './Container';
import Component from './Component';

export const RetailersListItem = Component;

export default Container;
